import { Vue, Component } from 'vue-property-decorator';
import template from './manifesto-video.vue';

@Component({
  mixins: [template],
})
export default class ManifestoVideo extends Vue {

}
